// src/stores/planStore.js
import { defineStore } from 'pinia';

export const usePlanStore = defineStore('planStore', {
  state: () => ({
    selectedPlanId: null,
    fractionationDraft: {
      total_absorbed_dose: null,
      dose_per_fraction: null,
      number_of_fractions: null,
    },
    /** Пользователь сохранил D/d/n_f перед расчётом — не затирать историей курса. */
    fractionationDraftPinned: false,
    fractionationByPlanId: {},
  }),
  getters: {
    fractionationForSelected(state) {
      if (!state.selectedPlanId) return null;
      return state.fractionationByPlanId[state.selectedPlanId] || null;
    },
  },
  actions: {
    setSelectedPlanId(planId) {
      this.selectedPlanId = planId;
    },
    clearSelectedPlanId() {
      this.selectedPlanId = null;
    },
    setFractionationDraft(payload) {
      this.fractionationDraft = {
        total_absorbed_dose:
          payload?.total_absorbed_dose === '' || payload?.total_absorbed_dose == null
            ? null
            : Number(payload.total_absorbed_dose),
        dose_per_fraction:
          payload?.dose_per_fraction === '' || payload?.dose_per_fraction == null
            ? null
            : Number(payload.dose_per_fraction),
        number_of_fractions:
          payload?.number_of_fractions === '' || payload?.number_of_fractions == null
            ? null
            : Number(payload.number_of_fractions),
      };
    },
    attachDraftToPlan(planId) {
      if (!planId) return;
      const d = this.fractionationDraft;
      if (
        d?.total_absorbed_dose == null &&
        d?.dose_per_fraction == null &&
        d?.number_of_fractions == null
      ) {
        return;
      }
      this.fractionationByPlanId = {
        ...this.fractionationByPlanId,
        [planId]: { ...d },
      };
    },
    clearFractionationDraft() {
      this.fractionationDraft = {
        total_absorbed_dose: null,
        dose_per_fraction: null,
        number_of_fractions: null,
      };
      this.fractionationDraftPinned = false;
    },
    clearFractionationForPlan(planId) {
      if (!planId) return;
      const next = { ...(this.fractionationByPlanId || {}) };
      delete next[planId];
      this.fractionationByPlanId = next;
    },
  },
});
